import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class SoftwareSpecificSearchService {
  PrivacyTerms: boolean = false;
  formData: any;
  constructor(private http: HttpClient, private occService: OccEndpointsService,) { }

  getCustomDocumentDetails(searchDetails, pageSize, query, currentPage, sort?) {
    return this.http.get(this.occService.buildUrl(`softwareLibrary/kbsoftwares?pageSize=${pageSize}&page=${currentPage}&searchText=${query}&softwareGroup=${searchDetails?.softwareGroup}&softwareType=${searchDetails?.softwareType}&packageType=${searchDetails?.packageType}&softwareLanguage=${searchDetails?.language}&sort=${sort}`));
  }

  getSoftWareSearchPage() {
    return this.http.get(this.occService.buildUrl(`softwareLibrary/form/`));
  }

  getSoftwareDetailsPage(name: string) {
    return this.http.get(this.occService.buildUrl(`softwareLibrary/softwareDetails/${name}`));
  }
  getSoftwareDetailsPageforEmail(softwareCode:string) {
    return this.http.get(this.occService.buildUrl(`softwareLibrary/softwareDetails/softwareRequestCode/${softwareCode}`));
  }


  getSoftwareFormPage(code: string) {
    return this.http.get(this.occService.buildUrl(`softwareLibrary/softwareRequest?softwareCode=${code}`));
  }

  postSoftWareForm(PayLoad) {
  
    const file = new FormData();
    return this.http.post(this.occService.buildUrl(`softwareLibrary/softwareRequest?softwareCode=${PayLoad.softwareCode}&firstName=${PayLoad.firstName}&lastName=${PayLoad.lastName}&postalCode=${PayLoad.postalCode}&country=${PayLoad.country}&emailID=${PayLoad.emailID}&companyName=${PayLoad.companyName}&softwareType=${PayLoad.softwareType}&captchaCode=${PayLoad.captchaCode}`), file);
  }
}
